export default {
  lang_name: 'Español',
  tab_main: 'Principal', tab_upgrade: 'Mejora', tab_prestige: 'Prestigio', tab_achievement: 'Logros', tab_mission: 'Misión', tab_domination: 'Mundo', tab_settings: 'Config.',
  hud_cps: '/s', hud_boost: 'Boost',
  main_tap_area: '¡TOCA!', main_combo: 'Combo',
  prod_informant: 'Informante', prod_informant_desc: 'Recopilación de intel callejera',
  prod_hacker: 'Hacker', prod_hacker_desc: 'Infiltración de redes',
  prod_disguiser: 'Disfrazador', prod_disguiser_desc: 'Camuflaje humano',
  prod_mindController: 'Controlador Mental', prod_mindController_desc: 'Manipulación de opiniones',
  prod_secretLab: 'Lab. Secreto', prod_secretLab_desc: 'Investigación reptiliana',
  prod_mediaCell: 'Célula Mediática', prod_mediaCell_desc: 'Control de noticias',
  prod_shadowGovt: 'Gob. en la Sombra', prod_shadowGovt_desc: 'Reemplazo de políticos',
  prod_deepBase: 'Base Profunda', prod_deepBase_desc: 'Mega-base subterránea',
  prod_orbitalStation: 'Estación Orbital', prod_orbitalStation_desc: 'Red de vigilancia satelital',
  prod_dimensionGate: 'Portal Dimensional', prod_dimensionGate_desc: 'Invocar fuerzas',
  prod_planetController: 'Control Planetario', prod_planetController_desc: 'Control directo de la Tierra',
  prod_galacticBeacon: 'Faro Galáctico', prod_galacticBeacon_desc: 'Línea directa al HQ',
  prod_locked: 'Desbloquear: ', prod_locked_prestige: 'Prestigio {n}x', prod_locked_time: '{n}min juego',
  milestone_squad: 'Escuadrón', milestone_company: 'Compañía', milestone_battalion: 'Batallón',
  milestone_regiment: 'Regimiento', milestone_division: 'División', milestone_corps: 'Cuerpo',
  click_basic_training: 'Entrenamiento Básico', click_combat_training: 'Entrenamiento de Combate',
  click_psychic_awaken: 'Despertar Psíquico', click_transform: 'Mejora de Transformación',
  click_telepathy: 'Telepatía', click_critical_eye: 'Ojo Crítico',
  click_dimension_sense: 'Sentido Dimensional', click_galaxy_field: 'Campo Galáctico',
  click_lethal_strike: 'Golpe Letal', click_absolute: 'Infiltración Absoluta',
  click_planet_destroyer: 'Destructor Planetario', click_galaxy_finger: 'Dedo del Overlord',
  special_info_network: 'Red de Info', special_info_network_desc: 'Informante y Hacker x2',
  special_perfect_disguise: 'Disfraz Perfecto', special_perfect_disguise_desc: 'Todos los agentes x1.5',
  special_mass_brainwash: 'Lavado de Cerebro Masivo', special_mass_brainwash_desc: 'Control Mental y Media x3',
  special_shadow_network: 'Red Sombría', special_shadow_network_desc: 'Ingreso offline +25%',
  special_underground_empire: 'Imperio Subterráneo', special_underground_empire_desc: 'Todos los agentes x2',
  special_orbital_surveillance: 'Vigilancia Orbital', special_orbital_surveillance_desc: 'Eventos dorados +50%',
  special_dimension_supply: 'Suministro Dimensional', special_dimension_supply_desc: 'Ingreso por toque x5',
  special_galactic_alliance: 'Alianza Galáctica', special_galactic_alliance_desc: '🛸 por segundo x10',
  special_combo_master: 'Maestro del Combo', special_combo_master_desc: 'Límite de combo x3',
  special_time_warp: 'Salto Temporal', special_time_warp_desc: 'Límite offline 12h',
  special_agent_synergy: 'Sinergia de Agentes', special_agent_synergy_desc: '🛸 por segundo x1.5',
  special_massive_infiltration: 'Infiltración Masiva', special_massive_infiltration_desc: '🛸 por segundo x2',
  subtab_click: 'Clic', subtab_special: 'Especial',
  prestige_title: 'Reestructuración', prestige_total_ip: '🛸 total ganado', prestige_gc_gain: '💎 a ganar',
  prestige_gc_current: '💎 actual', prestige_execute: 'Reestructurar',
  prestige_confirm: '¿Reiniciar progreso por {gc} Créditos Galácticos?',
  prestige_ad_bonus: 'Ver anuncio +50% 💎', prestige_requirement: 'Necesitas 10B+ 🛸',
  prestige2_title: 'Reestructuración Galáctica', prestige2_cores_gain: '🔮 a ganar',
  prestige2_cores_current: '🔮 actuales', prestige2_execute: 'Reestructuración Galáctica',
  prestige2_requirement: 'Necesitas 15+ prestigios y 100+ 💎', prestige2_confirm: '¿Reinicio profundo por {cores} Núcleos?',
  pup_galaxy_mult: 'Multiplicador Galáctico', pup_galaxy_mult_desc: 'CPS x1.5 por nivel (se acumula multiplicativamente)',
  pup_infil_accel: 'Aceleración de Infiltración', pup_infil_accel_desc: 'Empezar con 100M 🛸 por nivel tras prestigio',
  pup_tap_enhance: 'Mejora de Toque', pup_tap_enhance_desc: 'Ingreso por toque x2 por nivel (se acumula)',
  pup_offline_expand: 'Expansión Offline', pup_offline_expand_desc: 'Límite recompensa offline +1h/Nv (base 8h)',
  pup_offline_eff: 'Eficiencia Offline', pup_offline_eff_desc: 'Tasa ingreso offline +10%p/Nv (base 50%)',
  pup_agent_discount: 'Descuento de Agente', pup_agent_discount_desc: 'Costo agentes -10% por nivel (máx -50%)',
  pup_auto_click: 'Auto Clic', pup_auto_click_desc: 'Auto-toque 3/seg por nivel (máx 15/seg)',
  pup_golden_luck: 'Suerte Dorada', pup_golden_luck_desc: 'Recompensa evento dorado +20%/Nv (máx +200%)',
  pup_combo_keep: 'Mantener Combo', pup_combo_keep_desc: 'Duración combo +0.5s/Nv (base 2s)',
  pup_quick_start: 'Inicio Rápido', pup_quick_start_desc: 'Obtener 1 de los primeros 5 agentes tras prestigio',
  p2up_galaxy_speed: 'Velocidad Galáctica', p2up_galaxy_speed_desc: '💎 ganados x2 por nivel en prestigio (acumulable)',
  p2up_auto_prestige: 'Auto Prestigio', p2up_auto_prestige_desc: 'Prestigio automático al alcanzar 10B 🛸',
  p2up_permanent: 'Agentes Permanentes', p2up_permanent_desc: 'Conservar primeros 3 tipos de agentes tras prestigio',
  p2up_dimension_accel: 'Aceleración Dimensional', p2up_dimension_accel_desc: 'CPS x5 por nivel (acumulable, permanente)',
  p2up_galaxy_memory: 'Memoria Galáctica', p2up_galaxy_memory_desc: 'Conservar 3 mejoras activas tras prestigio',
  p2up_spacetime: 'Curvatura Espaciotemporal', p2up_spacetime_desc: 'Tasa ingreso offline al 100% (permanente)',
  p2up_automate: 'Automatización Galáctica', p2up_automate_desc: 'Contratar agentes automáticamente (permanente)',
  rank_e: 'Interno', rank_d: 'Agente Junior', rank_c: 'Agente', rank_b: 'Agente Senior',
  rank_a: 'Ejecutivo', rank_s: 'Director', rank_ss: 'Comandante Supremo', rank_sss: 'Overlord Galáctico',
  ach_title: 'Logros', ach_filter_all: 'Todos', ach_filter_tap: 'Toque', ach_filter_resource: 'Recurso',
  ach_filter_producer: 'Productor', ach_filter_prestige: 'Prestigio', ach_filter_time: 'Tiempo',
  ach_filter_special: 'Especial', ach_filter_ad: 'Docs', ach_filter_combo: 'Combo',
  ach_t01: 'Primer Paso', ach_t01_reward: '+1 Poder de Toque', ach_t02: 'Calentamiento', ach_t02_reward: '+5% Poder de Toque',
  ach_t03: 'Agente Constante', ach_t03_reward: '+10% Poder de Toque', ach_t04: 'Maestro del Toque', ach_t04_reward: '+15% Poder de Toque',
  ach_t05: 'Determinación Reptiliana', ach_t05_reward: '+20% Poder de Toque', ach_t06: 'Dedos Galácticos', ach_t06_reward: '+25% Poder de Toque',
  ach_t07: 'Aprendiz de Combo', ach_t07_reward: '+0.5s Combo', ach_t08: 'Maestro del Combo', ach_t08_reward: '+0.5 Límite Combo',
  ach_r01: 'Pequeña Intel', ach_r01_reward: '+5% \u{1F6F8}/s', ach_r02: 'Colector de Intel', ach_r02_reward: '+5% \u{1F6F8}/s',
  ach_r03: 'Bóveda Clasificada', ach_r03_reward: '+5% \u{1F6F8}/s', ach_r04: 'Infiltración Millonaria', ach_r04_reward: '+10% \u{1F6F8}/s',
  ach_r05: 'Agente Billonario', ach_r05_reward: '+10% \u{1F6F8}/s', ach_r06: 'Ops Trillón', ach_r06_reward: '+15% \u{1F6F8}/s',
  ach_r07: 'Imperio Cuatrillón', ach_r07_reward: '+15% \u{1F6F8}/s', ach_r08: 'Océano Galáctico', ach_r08_reward: '+20% \u{1F6F8}/s',
  ach_r09: 'Universo Cósmico', ach_r09_reward: '+20% \u{1F6F8}/s', ach_r10: 'Infiltración Infinita', ach_r10_reward: '+30% \u{1F6F8}/s',
  ach_g01: 'Primera Recluta', ach_g01_reward: 'Informante x1.5', ach_g02: 'Red de Intel', ach_g02_reward: 'Informante x2',
  ach_g03: 'Empieza el Hackeo', ach_g03_reward: 'Hacker x2', ach_g04: 'Ciber Legión', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Maestro del Disfraz', ach_g05_reward: 'Disfrazador x2', ach_g06: 'Red de Lavado', ach_g06_reward: 'Control Mental x2',
  ach_g07: 'Ciencia Loca', ach_g07_reward: 'Lab. Secreto x2', ach_g08: 'Control Mediático', ach_g08_reward: 'Célula Mediática x2',
  ach_g09: 'Gabinete Sombra', ach_g09_reward: 'Gob. en la Sombra x2', ach_g10: 'Imperio Subterráneo', ach_g10_reward: 'Base Profunda x2',
  ach_g11: 'Dominancia Orbital', ach_g11_reward: 'Estación Orbital x2', ach_g12: 'Maestro Galáctico', ach_g12_reward: '\u{1F6F8}/s Total x2',
  ach_p01: 'Primera Reestructuración', ach_p01_reward: '+5 💎 Bonus', ach_p02: 'Sabor del Ciclo', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veterano', ach_p03_reward: '+10% 💎', ach_p04: 'Adicto al Prestigio', ach_p04_reward: '+15% 💎',
  ach_p05: 'Bucle Infinito', ach_p05_reward: '+20% 💎', ach_p06: 'Memoria Galáctica', ach_p06_reward: '+25% 💎',
  ach_p07: 'Reestructuración Galáctica', ach_p07_reward: '+3 🔮 Bonus', ach_p08: 'Señor Dimensional', ach_p08_reward: '+20% 🔮',
  ach_h01: 'Nuevo Recluta', ach_h01_reward: 'Bonus Bienvenida 100 🛸', ach_h02: 'Turno de 1 Hora', ach_h02_reward: '+5% \u{1F6F8}/s',
  ach_h03: 'Medio Día', ach_h03_reward: '+10% \u{1F6F8}/s', ach_h04: 'Vigilancia 24h', ach_h04_reward: 'Offline +2h',
  ach_h05: 'Misión de 3 Días', ach_h05_reward: '\u{1F6F8}/s x1.5', ach_h06: 'Infiltración Semanal', ach_h06_reward: '\u{1F6F8}/s x2',
  ach_s01: 'Humano Sospechoso', ach_s01_reward: '1 Doc', ach_s02: 'Inicio Limpio', ach_s02_reward: 'Título: Agente Temerario',
  ach_s03: 'Todo Adentro', ach_s03_reward: '+10% \u{1F6F8}/s', ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Cazador Dorado', ach_s05_reward: 'Frecuencia evento -20%', ach_s06: 'Agente Nocturno', ach_s06_reward: '\u{1F6F8}/s nocturno x1.5',
  ach_s07: 'Guerrero F2P', ach_s07_reward: 'Recompensa ad +30%', ach_s08: 'Coleccionista', ach_s08_reward: '\u{1F6F8}/s x3',
  ach_a01: 'Principiante de Ads', ach_a01_reward: '1 Doc', ach_a02: 'Entusiasta de Ads', ach_a02_reward: '2 Docs',
  ach_a03: 'Maestro de Ads', ach_a03_reward: 'Recompensa ad +30%', ach_a04: 'Colector de Docs', ach_a04_reward: 'Efecto doc +20%',
  ach_a05: 'Experto en Docs', ach_a05_reward: 'Efecto doc +50%',
  ach_c01: 'Inicio Combo', ach_c01_reward: '+0.3s Combo', ach_c02: 'En el Ritmo', ach_c02_reward: '+0.1 Mult Combo',
  ach_c03: 'Principiante Dorado', ach_c03_reward: 'Recompensa evento +10%', ach_c04: 'Colector Dorado', ach_c04_reward: 'Frecuencia evento -10%',
  ach_c05: 'Maníaco Diario', ach_c05_reward: 'Recompensa misión +50%',
  golden_intel_leak: '¡Fuga de Intel!', golden_agent_frenzy: '¡Frenesí de Agentes!', golden_money_launder: '¡Lavado de Dinero!',
  golden_facility_boost: '¡Sobremarcha!', golden_supply_drop: '¡Suministro Galáctico!', golden_touch: '¡TOCA!',
  golden_ad_double: 'Ver anuncio para 2x',
  offline_title: 'Informe de Ausencia', offline_elapsed: 'Tiempo transcurrido', offline_earned: '🛸 ganado',
  offline_cap: 'Máx {h}h aplicado', offline_claim: 'Reclamar', offline_double: 'Ver anuncio para 2x ({amount})',
  offline_hours: '{h}h {m}m',
  settings_title: 'Configuración', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_lang: 'Idioma',
  settings_reset: 'Reiniciar Juego', settings_reset_confirm: '¿Borrar TODO el progreso?',
  settings_stats: 'Estadísticas', settings_total_ip: '🛸 Total Ganado', settings_total_taps: 'Toques Totales',
  settings_total_prestiges: 'Prestigios Totales', settings_play_time: 'Tiempo Total', settings_docs_shop: 'Tienda de Docs',
  doc_shop_title: 'Tienda de Docs Clasificados',
  doc_ip_boost: 'Acelerador de Ingresos', doc_ip_boost_desc: '2x produccion 🛸/s por 30 seg',
  doc_mega_tap: 'Entrenamiento de Toque', doc_mega_tap_desc: '3x ingreso por toque por 30 seg',
  doc_auto_click: 'Auto-Infiltrador', doc_auto_click_desc: 'Auto-toque 10/seg por 30 seg',
  doc_instant_golden: 'Llamada Dorada', doc_instant_golden_desc: 'Activar evento dorado al instante',
  doc_timeskip: 'Acelerador Temporal', doc_timeskip_desc: 'Obtener 2 horas de ingresos 🛸 al instante',
  doc_prestige_boost: 'Amplificador Galactico', doc_prestige_boost_desc: '2x 💎 en proximo prestigio',
  doc_prestige_boost_active: '💎 x2 pendiente para proximo prestigio', doc_prestige_boost_active_badge: '✅ Activo',
  ad_offline_double: 'Doble recompensa offline', ad_cps_boost: 'Ingreso/s x10 Boost (15s)',
  ad_prestige_bonus: 'Prestigio +50% 💎', ad_timeskip: 'Salto Temporal (2h)', ad_free_docs: 'Docs Gratis',
  ad_golden_double: 'Doble recompensa dorada', ad_start_boost: 'Pack de Inicio',
  ad_watching: 'Cargando anuncio...', ad_cooldown: 'Disponible en {t}',
  settings_sfx_test: 'Probar SFX', settings_sound_reset: 'Restablecer', settings_sound_reset_done: 'Sonido restablecido',
  num_k: 'K', num_m: 'M', num_b: 'B', num_t: 'T', num_qa: 'Qa', num_qi: 'Qi', num_sx: 'Sx', num_sp: 'Sp', num_oc: 'Oc', num_no: 'No', num_dc: 'Dc',
  mission_title: 'Misiones Diarias',
  mission_claim: 'Reclamar',
  mission_all_complete: 'Bonus por completar todo!',
  mission_clear_label: 'MISI\u00D3N',
  mission_all_clear_label: 'TODO LISTO',
  ach_unlock_label: 'LOGRO',
  mission_diff_easy: 'Facil',
  mission_diff_normal: 'Med',
  mission_diff_hard: 'Duro',
  mission_tap_100: 'Toque Ligero', mission_tap_100_desc: 'Tocar 100 veces',
  mission_tap_300: 'Manos Calientes', mission_tap_300_desc: 'Tocar 300 veces',
  mission_buy_5: 'Recluta Menor', mission_buy_5_desc: 'Comprar 5 productores',
  mission_combo_10: 'Inicio Combo', mission_combo_10_desc: 'Alcanzar 10 combo',
  mission_golden_1: 'Captura Dorada', mission_golden_1_desc: 'Atrapar 1 evento dorado',
  mission_tap_1000: 'Golpe Fuerte', mission_tap_1000_desc: 'Tocar 1.000 veces',
  mission_buy_20: 'Constructor de Escuadron', mission_buy_20_desc: 'Comprar 20 productores',
  mission_combo_50: 'Combo Pro', mission_combo_50_desc: 'Alcanzar 50 combo',
  mission_golden_3: 'Fiebre del Oro', mission_golden_3_desc: 'Atrapar 3 eventos dorados',
  mission_earn_1m: 'Operacion Millon', mission_earn_1m_desc: 'Ganar 1M 🛸',
  mission_tap_5000: 'Maquina de Toques', mission_tap_5000_desc: 'Tocar 5.000 veces',
  mission_buy_50: 'Constructor de Ejercito', mission_buy_50_desc: 'Comprar 50 productores',
  mission_combo_100: 'Dios del Combo', mission_combo_100_desc: 'Alcanzar 100 combo',
  mission_golden_5: 'Maestro Dorado', mission_golden_5_desc: 'Atrapar 5 eventos dorados',
  mission_earn_1b: 'Agente Billonario', mission_earn_1b_desc: 'Ganar 1B 🛸',
  mission_tap_200: 'Dedos rápidos',
  mission_tap_200_desc: 'Toca 200 veces',
  mission_buy_3: 'Primeros reclutas',
  mission_buy_3_desc: 'Compra 3 productores',
  mission_combo_15: 'Combo principiante',
  mission_combo_15_desc: 'Alcanza 15 combo',
  mission_earn_10k: 'Dinero de bolsillo',
  mission_earn_10k_desc: 'Gana 10K 🛸',
  mission_earn_100k: 'Recaudador',
  mission_earn_100k_desc: 'Gana 100K 🛸',
  mission_tap_500: 'Toque constante',
  mission_tap_500_desc: 'Toca 500 veces',
  mission_tap_700: 'Imparable',
  mission_tap_700_desc: 'Toca 700 veces',
  mission_buy_10: 'Líder de equipo',
  mission_buy_10_desc: 'Compra 10 productores',
  mission_combo_30: 'Cadena de combo',
  mission_combo_30_desc: 'Alcanza 30 combo',
  mission_golden_2: 'Doble oro',
  mission_golden_2_desc: 'Atrapa 2 eventos dorados',
  mission_tap_3000: 'Guerrero del toque',
  mission_tap_3000_desc: 'Toca 3.000 veces',
  mission_buy_30: 'Batallón',
  mission_buy_30_desc: 'Compra 30 productores',
  mission_combo_75: 'Combo élite',
  mission_combo_75_desc: 'Alcanza 75 combo',
  mission_golden_4: 'Cazador de oro',
  mission_golden_4_desc: 'Atrapa 4 eventos dorados',
  mission_earn_10m: 'Magnate',
  mission_earn_10m_desc: 'Gana 10M 🛸',
  // Conquest
  cq_title: 'Conquista Mundial',
  cq_progress: 'Conquistado',
  cq_infiltration_power: 'Poder de infiltración',
  cq_active_conquest: 'Infiltrando',
  cq_infiltration_progress: 'Progreso de infiltración',
  cq_time_remaining: 'Tiempo estimado',
  cq_start_infiltration: 'Iniciar infiltración',
  cq_stop_infiltration: 'Detener infiltración',
  cq_no_power_hint: 'Contrata agentes para generar poder de infiltración',
  cq_locked: 'Bloqueado',
  cq_available: 'Disponible',
  cq_conquered: 'Conquistado',
  cq_popup_title: '¡Conquista Completa!',
  cq_popup_desc: 'ha sido conquistado. ¡Construye instalaciones para ser más fuerte!',
  cq_back: 'Volver',
  cq_invest_title: 'Invertir 🛸 para conquistar',
  cq_current_ip: '🛸 actual',
  cq_facilities: 'Instalaciones',
  cq_build: 'Construir',
  cq_upgrade: 'Mejorar',
  cq_next_level: 'Siguiente',
  cq_counter_intel_title: 'Alerta de contraespionaje!',
  cq_counter_intel_text: 'Tu infiltración en {country} ha sido detectada! El progreso se reducirá.',
  cq_defend_ad: 'Ver anuncio para defender',
  cq_accept_loss: 'Aceptar pérdida',
  cq_ending_title: 'Tierra conquistada!',
  cq_ending_text: 'La conspiración reptiliana está completa. Todas las naciones se inclinan ante el imperio de las sombras.',
  cq_ending_time: 'Tiempo de juego',
  cq_ending_prestiges: 'Prestigios',
  cq_ending_total_ip: '🛸 total',
  cq_ending_taps: 'Toques totales',
  cq_ending_continue: 'Seguir jugando',
  cq_egypt: 'Egipto', cq_egypt_desc: 'Bases antiguas de pirámides',
  cq_brazil: 'Brasil', cq_brazil_desc: 'Escondites en la selva amazónica',
  cq_india: 'India', cq_india_desc: 'Infiltración del culto Naga',
  cq_australia: 'Australia', cq_australia_desc: 'Búnkeres subterráneos del desierto',
  cq_japan: 'Japón', cq_japan_desc: 'Operaciones de robo tecnológico',
  cq_korea: 'Corea', cq_korea_desc: 'Brecha en defensa cibernética NIS',
  cq_uk: 'Reino Unido', cq_uk_desc: 'Infiltración real MI5/MI6',
  cq_russia: 'Rusia', cq_russia_desc: 'Operaciones siberianas FSB',
  cq_china: 'China', cq_china_desc: 'La vigilancia más fuerte del mundo',
  cq_usa: 'Estados Unidos', cq_usa_desc: 'CIA/NSA jefe final',
  fac_pyramid_vault: 'Bóveda Pirámide', fac_pyramid_vault_d: '\u{1F6F8}/s +5% por nivel',
  fac_nile_network: 'Red del Nilo', fac_nile_network_d: 'Offline +5% por nivel',
  fac_ancient_lab: 'Lab Antiguo', fac_ancient_lab_d: 'TAP +10% por nivel',
  fac_amazon_hideout: 'Escondite Amazónico', fac_amazon_hideout_d: 'Descuento +2% por nivel',
  fac_samba_broadcast: 'Emisora Samba', fac_samba_broadcast_d: '\u{1F6F8}/s +8% por nivel',
  fac_jungle_lab: 'Lab de la Selva', fac_jungle_lab_d: 'Golden +5% por nivel',
  fac_naga_temple: 'Templo Naga', fac_naga_temple_d: '💎 +5% por nivel',
  fac_bollywood_studio: 'Estudio Bollywood', fac_bollywood_studio_d: 'Offline +8% por nivel',
  fac_caste_network: 'Red de Castas', fac_caste_network_d: '\u{1F6F8}/s +12% por nivel',
  fac_desert_bunker: 'Búnker del Desierto', fac_desert_bunker_d: 'TAP +15% por nivel',
  fac_ayers_signal: 'Señal Ayers', fac_ayers_signal_d: 'Golden +8% por nivel',
  fac_outback_base: 'Base Outback', fac_outback_base_d: '\u{1F6F8}/s +15% por nivel',
  fac_akiba_ai: 'IA Akihabara', fac_akiba_ai_d: '\u{1F6F8}/s +20% por nivel',
  fac_ninja_intel: 'Intel Ninja', fac_ninja_intel_d: 'Descuento +3% por nivel',
  fac_tokyo_tower: 'Torre de Tokio', fac_tokyo_tower_d: '💎 +8% por nivel',
  fac_gangnam_hq: 'HQ Gangnam', fac_gangnam_hq_d: '\u{1F6F8}/s +25% por nivel',
  fac_cyber_command: 'Comando Cibernético', fac_cyber_command_d: 'TAP +25% por nivel',
  fac_kpop_brainwash: 'Lavado K-Pop', fac_kpop_brainwash_d: '💎 +10% por nivel',
  fac_royal_infiltrate: 'Infiltración Real', fac_royal_infiltrate_d: '\u{1F6F8}/s +30% por nivel',
  fac_london_tower: 'Torre de Londres', fac_london_tower_d: 'Offline +15% por nivel',
  fac_mi6_double: 'Agente Doble MI6', fac_mi6_double_d: 'Golden +12% por nivel',
  fac_siberia_base: 'Base Siberiana', fac_siberia_base_d: '\u{1F6F8}/s +40% por nivel',
  fac_kgb_remnant: 'Remanente KGB', fac_kgb_remnant_d: 'Descuento +5% por nivel',
  fac_nuke_bunker: 'Búnker Nuclear', fac_nuke_bunker_d: 'TAP +40% por nivel',
  fac_great_wall: 'Gran Firewall', fac_great_wall_d: '\u{1F6F8}/s +50% por nivel',
  fac_shenzhen_factory: 'Fábrica Shenzhen', fac_shenzhen_factory_d: 'Descuento +8% por nivel',
  fac_panda_spy: 'Red Espía Panda', fac_panda_spy_d: 'Golden +20% por nivel',
  fac_area51: 'Área 51', fac_area51_d: '\u{1F6F8}/s +80% por nivel',
  fac_pentagon: 'Pentágono', fac_pentagon_d: 'TAP +80% por nivel',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% por nivel',

  buy: 'Comprar', max: 'MAX', level: 'Nv.', locked: 'Bloqueado', unlocked: 'Desbloqueado',
  upgrade_locked_prev: 'Aprende la mejora anterior primero',
  condition: 'Condición', cost: 'Costo', owned: 'Poseído', effect: 'Efecto', reward: 'Recompensa',
  close: 'Cerrar', confirm: 'Confirmar', cancel: 'Cancelar',

  // Conquest achievements
  ach_filter_conquest: 'Conquista',
  ach_q01: 'Primera Conquista', ach_q01_reward: '\u{1F6F8}/s +10%',
  ach_q02: 'Triple Amenaza', ach_q02_reward: 'TAP +10%',
  ach_q03: 'Medio Mundo', ach_q03_reward: '💎 +15%',
  ach_q04: 'Siete Banderas', ach_q04_reward: 'Offline +20%',
  ach_q05: 'Dominador Mundial', ach_q05_reward: '\u{1F6F8}/s x3',
  ach_q06: 'Maestro de Instalaciones', ach_q06_reward: '\u{1F6F8}/s x2',
  milestone_next: 'Siguiente',
  settings_conquest: 'Conquista',

  // Currency info
  currency_ip_name: 'Puntos de Infiltración (IP)',
  currency_ip_earn: 'Toca, producción automática, ingresos offline y recompensas de anuncios',
  currency_ip_use: 'Contratar agentes, comprar mejoras, invertir en conquistas',
  currency_gc_name: 'Créditos Galácticos (GC)',
  currency_gc_earn: 'Al hacer prestige (Reestructuración) según IP total acumulado',
  currency_gc_use: 'Comprar mejoras de prestige (multiplicador de producci\u00F3n, eficiencia offline, etc.)',
  currency_cores_name: 'Núcleos Galácticos',
  currency_cores_earn: 'Al hacer 2º prestige (Reestructuración Galáctica) según GC total',
  currency_cores_use: 'Comprar mejoras de 2º prestige (buffs permanentes, automatización, etc.)',
  currency_docs_name: 'Documentos Clasificados',
  currency_docs_earn: 'Misiones diarias, ver anuncios o desbloquear logros',
  currency_docs_use: 'Comprar boosts potentes en la Tienda de Docs (pestaña Misión)',
  currency_how_earn: 'Cómo obtener',
  currency_how_use: 'Cómo usar',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Maestría de Infiltración',
  pup_infiltration_mastery_desc: 'Poder de infiltración total +50%/Nv (máx +500%)',
  pup_agent_network: 'Red de Agentes',
  pup_agent_network_desc: 'Infiltración +5% por cada 100 agentes por nivel',
  pup_quick_infiltration: 'Infiltración en Cadena',
  pup_quick_infiltration_desc: 'Al conquistar: siguiente país +10% progreso/Nv',
  pup_critical_chance: 'Entrenamiento Crítico',
  pup_critical_chance_desc: 'Prob. crítico +3%/Nv (base 10%, máx 50%)',
  pup_critical_damage: 'Poder Crítico',
  pup_critical_damage_desc: 'Daño crítico +1x/Nv (base x3)',

  // Special upgrades - conquest
  special_spy_master: 'Maestro Espía',
  special_spy_master_desc: 'Poder de infiltración total x2',

  ad_income_x5: 'Ingresos de 30min',
  ad_income_x5_desc: '¡Mira un anuncio para obtener\n{amount} 🛸 al instante (30 minutos de ingresos)!',
  ad_tap_x10: 'Toque x10 (10s)',
  ad_tap_x10_desc: '¡Mira un anuncio para aumentar\nel ingreso por toque x10 durante 10 segundos!',
  ad_free_docs_desc: '¡Mira un anuncio para obtener\n1 Documento Clasificado 📜 gratis!',
  ad_prestige_desc: '¡Mira un anuncio para aumentar\nlos ingresos x10 durante 15 segundos!',
  cq_tutorial_title: '🌍 Guía de Conquista Mundial',
  cq_tutorial_text: 'Después de conquistar un país, ¡puedes construir <b>instalaciones</b>!\nMejóralas para obtener bonificaciones permanentes\ncomo <b>IPS, ingreso por toque, ingreso offline</b> y más.\n\nContrata agentes para aumentar el poder de infiltración.',
  rank_promote: 'Ascender',
  rank_promoted: '¡Ascenso completado!',
} as const;
